import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, Renderer2} from '@angular/core';
import {FacetFilterComponent} from '../facet-filter/facet-filter.component';
import {FacetSearchService} from '@app/services/facet-search.service';
import {ProductListComponentService} from '@spartacus/storefront';
import {DcpEddlSearchTrackingService} from '@app/services/analytics/EDDL/dcp-eddl-search-tracking.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FacetValue} from '@spartacus/core';
import {DcpHttpUrlEncodingService} from '@app/services/dcp-url-parameter-codec.service';

@Component({
  selector: 'dcp-mobile-facet-value',
  templateUrl: './mobile-facet-value.component.html',
  styleUrls: ['./mobile-facet-value.component.scss']
})
export class MobileFacetValueComponent extends FacetFilterComponent implements AfterViewInit {
  selectedFacets: string[];
  constructor(
    public cdr: ChangeDetectorRef,
    public facetSearchService: FacetSearchService,
    protected productListComponentService: ProductListComponentService,
    protected eddlSearchTrackingService: DcpEddlSearchTrackingService,
    protected el: ElementRef,
    protected renderer: Renderer2,
    protected router: Router,
    protected activatedRoute: ActivatedRoute,
  ) {
    super(cdr, facetSearchService, productListComponentService, eddlSearchTrackingService, el, renderer, router, activatedRoute);
    this.queryCodec = new DcpHttpUrlEncodingService();
  }
  ngAfterViewInit() {
    this.selectedFacets = this.getSelectedFacetNames();
  }

  onSelect(e: any) {
    if (!!e.target.selected) {
      this.selectedFacets.push(e.target._state.label);
    } else {
      this.selectedFacets = this.selectedFacets.filter(facet => facet === e.target._state.label);
    }
    this.toggleFacetValueList(this.selectedFacets);
  }

  toggleFacetValueList(facetValueNames: string[]) {
    facetValueNames.forEach(facetValueName => {
      const toggledFacetValue: FacetValue = this.getFacetValueByName(facetValueName);
      const query: string = this.queryCodec.decodeValue(toggledFacetValue.query.query.value).replace(/\+/g, ' ');
      this.route({query, currentPage: undefined});
    });
  }

  getFacetValueByName(facetValueNames: string): FacetValue {
    return this.facet.values.find(facetValue => facetValue.name === facetValueNames);
  }

  onSearchChange(e: CustomEvent): void {
    this.filteredFacetValues = (!e.detail.value) ? this.facet.values : (this.facet.values.filter(
      value => value?.name?.toLowerCase()?.includes(e.detail.value.toLowerCase())
    ));
  }

  onSearchReset(): void {
    this.filteredFacetValues = this.facet.values;
  }
}
